module.exports = __webpack_public_path__ + "static/media/boat.517f36b3.svg";